import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase/index';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { MakeFields } from './validation/fields';
import { schema } from './validation/schema';

const ChangePassRipleyCom = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm={issueForm}
        mobile={mobile}
        title=""
        buttonTitle="Enviar solicitud"
        data={data}
        fields={MakeFields()}
        formName="changePassRipleyCom"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        motiveId={motiveId}
        typeId={typeId}
        schema={schema}
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            typeId={typeId}
            fields={MakeFields()}
          />
        }
      />
    </React.Fragment>
  );
};

ChangePassRipleyCom.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
  issueForm: PropTypes.bool,
};

export default ChangePassRipleyCom;
